import httpClient from '../../config/accountRecoveryHttp.client'

export const request = ({ url, method = 'POST', headers = {}, data }) =>
  httpClient.request({ url, method, headers, data })
